export default __webpack_public_path__ + "static/media/prospect-add.264415af.svg";